import {KEYS} from './keysStorage'

export enum ROLES {
  FACTURADOR = 1,
  SUPERVISOR = 2,
  ADMINISTRADOR = 3,
}

export const ROL_POR_OMISION = ROLES.FACTURADOR

export const NOMBRES_ROLES: Record<number, string> = {
  [ROLES.FACTURADOR]: 'Facturador',
  [ROLES.SUPERVISOR]: 'Supervisor',
  [ROLES.ADMINISTRADOR]: 'Administrador',
}

export interface OpcionRol {
  id: ROLES
  nombre: string
}

export const CATALOGO_ROLES: Array<OpcionRol> = [
  {id: ROLES.FACTURADOR, nombre: NOMBRES_ROLES[ROLES.FACTURADOR]},
  {id: ROLES.SUPERVISOR, nombre: NOMBRES_ROLES[ROLES.SUPERVISOR]},
]

export const esRolValido = (rol: any): boolean => NOMBRES_ROLES[Number(rol)] !== undefined

export const resolverRolID = (rol: any): ROLES =>
  esRolValido(rol) ? (Number(rol) as ROLES) : ROL_POR_OMISION

export const nombreRol = (rol: any): string => NOMBRES_ROLES[resolverRolID(rol)]

const datosDeSesion = (sesion: any): any => (sesion?.datos ? sesion.datos : sesion) ?? {}

const rolAlmacenado = (): string | null => {
  try {
    return localStorage.getItem(KEYS.ROL)
  } catch (error) {
    return null
  }
}

export const obtenerRolID = (sesion: any): ROLES => {
  const datos = datosDeSesion(sesion)
  const candidatos = [datos.rolID, datos.role, datos.role_access_user, datos.rol, rolAlmacenado()]
  const encontrado = candidatos.find((valor) => esRolValido(valor))
  return resolverRolID(encontrado)
}

export const esSuperusuario = (sesion: any): boolean => {
  const datos = datosDeSesion(sesion)
  const valor = datos.superuser ?? datos.is_superuser ?? datos.superUsuario
  if (typeof valor === 'string')
    return valor.trim().toLowerCase() === 'true' || valor.trim() === '1'
  if (typeof valor === 'number') return valor === 1
  return valor === true
}

export const tieneAlgunRol = (sesion: any, roles: Array<ROLES>): boolean => {
  if (esSuperusuario(sesion)) return true
  if (!roles || roles.length === 0) return true
  return roles.map((rol) => Number(rol)).includes(Number(obtenerRolID(sesion)))
}

export const esFacturador = (sesion: any): boolean => tieneAlgunRol(sesion, [ROLES.FACTURADOR])

export const esSupervisor = (sesion: any): boolean => tieneAlgunRol(sesion, [ROLES.SUPERVISOR])

export const esAdministrador = (sesion: any): boolean =>
  tieneAlgunRol(sesion, [ROLES.ADMINISTRADOR])

export const ROLES_ADMINISTRACION_EMPRESA: Array<ROLES> = [ROLES.SUPERVISOR, ROLES.ADMINISTRADOR]

export const ROLES_GESTION_DE_ROLES: Array<ROLES> = [ROLES.SUPERVISOR, ROLES.ADMINISTRADOR]

export const ROLES_MIGRACION_NORMATIVA: Array<ROLES> = [ROLES.SUPERVISOR, ROLES.ADMINISTRADOR]
